import { cn } from "@dalmatech/ui"

const root = cn("w-full")
const breadcrumbSkeleton = cn("mx-auto mb-10 h-6 w-full max-w-xs lg:hidden")

export { breadcrumbSkeleton, root }
